import { styled } from "styled-components";

export const TrainingWrapper = styled.div`
  padding: 80px 0 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0 0;
  }
`;

export const TrainingNavList = styled.ul`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  background-color: #fbfbfb;
  z-index: 1;
  li {
    font-size: 24px;
    line-height: 1.3;
    font-weight: bold;
    cursor: pointer;
    color: #c1c1c1;
    &.active {
      color: #171717;
    }
  }
  @media all and (max-width: 1024px) {
    top: 80px;
  }
  @media all and (max-width: 768px) {
    top: 60px;
    gap: 5.208vw;
    height: 10.417vw;
    li {
      font-size: 3.385vw;
    }
  }
`;

export const TrainingWrap = styled.div``;
export const TrainigTitleWrap = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;
export const TrainigTitleContainer = styled.div`
  h4 {
    color: #171717;
    font-size: 56px;
    line-height: 1.2;
    text-align: center;
    font-weight: bold;
  }
  @media all and (max-width: 768px) {
    h4 {
      font-size: 7.813vw;
    }
  }
`;

export const refWrap = styled.div``;
export const EntranceWrap = styled(refWrap)`
  background-color: #171717;
  color: #fbfbfb;
`;
export const AuditionWrap = styled(refWrap)``;
export const LicenseWrap = styled(refWrap)`
  background-color: #f7f7f7;
`;

export const refContainer = styled.div`
  padding: 80px 0;
  .title-area {
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: center;
    align-items: center;
    margin-bottom: 48px;
    text-align: center;
    h4 {
      font-size: 56px;
      line-height: 1.2;
      font-weight: bold;
    }
    > div {
      display: flex;
      flex-direction: column;
      gap: 16px;
      justify-content: center;
      align-items: center;
    }
    span {
      font-size: 24px;
      line-height: 1.3;
      font-weight: bold;
    }
    p {
      text-align: center;
      font-size: 20px;
      line-height: 1.4;
      br {
        &.mobile {
          display: none;
        }
      }
    }
  }
  .list-area {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    li {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      span {
        font-size: 22px;
        line-height: 1.3;
        font-weight: bold;
        color: #c1c1c1;
      }
      p {
        font-size: 22px;
        line-height: 1.3;
        font-weight: bold;
        color: #171717;
      }
      .sub-text {
        color: #6f6f6f;
        font-weight: bold;
        font-size: 18px;
        line-height: 1.3;
      }
    }
  }
  @media all and (max-width: 768px) {
    padding: 10.417vw 0;
    .title-area {
      gap: 6.51vw;
      margin-bottom: 6.51vw;
      h4 {
        font-size: 7.813vw;
      }
      > div {
        gap: 2.344vw;
      }
      span {
        font-size: 4.167vw;
        word-break: keep-all;
        br {
          display: none;
        }
      }
      p {
        font-size: 3.646vw;
        br {
          display: none;
          &.mobile {
            display: block;
          }
        }
      }
    }
    .list-area {
      gap: 2.604vw;
      li {
        padding: 3.125vw;
        gap: 0.781vw;
        span {
          font-size: 3.906vw;
        }
        p {
          font-size: 3.646vw;
        }
        .sub-text {
          font-size: 3.385vw;
        }
      }
    }
  }
`;

export const EntranceContainer = styled(refContainer)`
  li {
    width: calc(20% - 80px / 5);
    border: 1px solid #efefef;
    span {
      color: #6f6f6f;
    }
    p {
      color: #fbfbfb !important;
    }
  }
  @media all and (max-width: 1024px) {
    li {
      width: calc(33.333% - 40px / 3);
      min-height: 170px;
    }
  }
  @media all and (max-width: 768px) {
    li {
      width: calc(50% - 1.302vw);
      min-height: 190px;
    }
  }
  @media all and (max-width: 640px) {
    li {
      width: 100%;
      min-height: 26.693vw;
    }
  }
`;
export const AuditionContainer = styled(refContainer)`
  li {
    width: calc(25% - 60px / 4);
    border: 1px solid #171717;
  }
  @media all and (max-width: 1024px) {
    li {
      width: calc(50% - 10px);
      min-height: 170px;
    }
  }
  @media all and (max-width: 768px) {
    li {
      width: calc(50% - 1.302vw);
    }
  }
  @media all and (max-width: 640px) {
    li {
      width: 100%;
      min-height: 26.693vw;
    }
  }
`;
export const LicenseContainer = styled(refContainer)`
  .img-area {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    i {
      padding: 44px 64px;
      background-color: #fff;
      border-radius: 20px;
      display: block;
      width: fit-content;
      img {
        width: 340px;
      }
    }
  }
  .license-list {
    width: 800px;
    margin: 0 auto;
    display: flex;
    gap: 12px;
    li {
      padding: 16px 24px;
      border: 1px solid #171717;
      width: calc(50% - 6px);
      display: flex;
      gap: 16px;
      span {
        color: #c1c1c1;
        font-weight: bold;
        font-size: 20px;
        line-height: 1.4;
      }
      p {
        color: #171717;
        font-weight: bold;
        font-size: 20px;
        line-height: 1.4;
      }
    }
  }
  @media all and (max-width: 900px) {
    .img-area {
      i {
        border-radius: 20px;
        padding: 30px 42px;
        img {
          width: 240px;
        }
      }
    }
    .license-list {
      width: 600px;
      gap: 12px;
      li {
        padding: 12px 16px;
        border: 1px solid #171717;
        width: calc(50% - 6px);
        gap: 16px;
        span {
          font-size: 18px;
        }
        p {
          font-size: 18px;
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    .img-area {
      i {
        border-radius: 3.906vw;
        padding: 5.208vw 6.771vw;
        img {
          width: 44.271vw;
        }
      }
    }
    .license-list {
      gap: 2.344vw;
      width: 78.125vw;
      li {
        padding: 2.865vw 3.385vw;
        gap: 2.083vw;
        flex-direction: column;
        span {
          font-size: 3.646vw;
        }
        p {
          font-size: 3.646vw;
          word-break: keep-all;
        }
      }
    }
  }
`;
